/**
 * 存放系统常量
 */
const ConstantManage = {
    // 文件展位图
    placeholderImage: require('../images/common/contract_placeholder.png'),
    // pdf.js 设置 常量
    PIXEL_RATIO: window.devicePixelRatio || 1,
    VIEWPORT_RATIO: 0.98
};

export default ConstantManage;
